import { SET_POP_UP } from 'client/constants';

const initialState = {
	id: null,
	data: null,
};

export default function(state = initialState, action) {
	switch (action.type) {
		case SET_POP_UP:
			return {
				...action.payload,
			};

		default:
			return state;
	}
}
